<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('rating_archive.title') }}</h1>
      <rating-list :archive="true" :id="id" :apiary="apiary"></rating-list>
      <b-row class="justify-content-end">
        <b-col class="flex-grow-0">
          <b-link class="form-control bg-primary text-light" @click.prevent="checkNetworkCreateRating">{{ $t('rating_create.title') }}</b-link>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalRating'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import RatingList from '../components/RatingList'
export default {
  name: 'RatingArchive',
  props: ['id', 'apiary'],
  components: { RatingList },
  methods: {
    checkNetworkCreateRating () {
      if (navigator.onLine) {
        this.$router.replace('/rating/create/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalRating')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalRating')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  a.form-control {
    white-space: nowrap;
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
</style>
